import CustomButton from '../../../Components/Common/CustomButton';
import Modal from '../../../Components/Common/Modal';
import { ButtonColor } from '../../../Utils/constants';

type ModalTypes = {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeDialog: () => void;
  errorMessage?: string;
};

const PaymentFailModal = ({ setIsModalOpen, closeDialog, errorMessage }: ModalTypes) => {
  return (
    <Modal title="Payment Failed" setIsModalOpen={setIsModalOpen}>
      <p className="text-[18.3px] text-gray-1 opacity-70 max-w-[786px] my-6 py-2">
        {errorMessage ? errorMessage : 'Your payment has failed.'}
      </p>

      <div className="flex justify-end">
        <CustomButton
          className="px-8 font-bold"
          colorClass={ButtonColor.DARK_BLUE}
          onClick={closeDialog}
        >
          Close
        </CustomButton>
      </div>
    </Modal>
  );
};

export default PaymentFailModal;
